import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const dataBR = (d) => {
  if (!d) return "-";
  const [y, m, day] = d.split("-");
  return `${day}/${m}/${y}`;
};
const mesLabel = (mes) => {
  const [y, m] = mes.split("-");
  const nomes = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  return `${nomes[Number(m) - 1]}/${y}`;
};

const AZUL = [37, 99, 235];

export function gerarFaturaPDF({ empresa, residente, fatura, getProduto, periodo = "", modo = "save" }) {
  const doc = new jsPDF();

  // Cabeçalho
  doc.setFillColor(...AZUL);
  doc.rect(0, 0, 210, 28, "F");
  let tx = 14;
  if (empresa?.logo) {
    try { doc.addImage(empresa.logo, "PNG", 12, 4, 20, 20); tx = 36; } catch (e) { /* ignore */ }
  }
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text(empresa?.nome || "Casa de Repouso São Jorge", tx, 13);
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(`CNPJ: ${empresa?.cnpj || "-"}`, tx, 20);
  doc.text(empresa?.email || "", tx, 24.5);
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.text("FATURA MENSAL", 196, 15, { align: "right" });

  // Dados do residente / fatura
  const fams = residente?.familiares || [];
  const resp = fams.find((f) => f.responsavelFinanceiro) || fams[0] || null;
  const respNome = resp?.nome || residente?.responsavel || "-";
  const respCpf = resp?.cpf || residente?.responsavelCpf || "-";
  const respEndereco = resp
    ? [resp.endLogradouro, resp.endNumero, resp.endBairro, resp.endCidade, resp.endUf].filter(Boolean).join(", ")
      + (resp.endCep ? ` - CEP ${resp.endCep}` : "")
    : "";

  doc.setTextColor(30, 41, 59);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("Residente", 14, 40);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(residente?.nome || "-", 14, 46);
  doc.text(`Quarto: ${residente?.quarto || "-"}   ·   CPF: ${residente?.cpf || "-"}`, 14, 51.5);
  doc.setFont("helvetica", "bold");
  doc.text("Responsável financeiro", 14, 59);
  doc.setFont("helvetica", "normal");
  doc.text(`${respNome}   ·   CPF: ${respCpf}`, 14, 64.5);
  if (respEndereco) {
    const linhasEnd = doc.splitTextToSize(respEndereco, 118);
    doc.text(linhasEnd, 14, 69.5);
  }

  doc.setFont("helvetica", "bold");
  doc.text("Referência", 150, 40);
  doc.setFont("helvetica", "normal");
  doc.text(mesLabel(fatura.mes), 150, 46);
  if (periodo) {
    doc.setFontSize(7.5);
    doc.setTextColor(120);
    doc.text(`Ciclo: ${periodo}`, 150, 49.5);
    doc.setTextColor(0);
    doc.setFontSize(9);
  }
  doc.setFont("helvetica", "bold");
  doc.text("Vencimento", 150, 53);
  doc.setFont("helvetica", "normal");
  doc.text(dataBR(fatura.vencimento), 150, 59);

  const manual = fatura.manual || [];

  // ---------- PARTE 1: Mensalidade e encargos ----------
  const mensalItens = [
    ...(fatura.extras || []).map((e) => ({ descricao: e.descricao, valor: e.valor })),
    ...manual.filter((m) => m.parte === "mensal").map((m) => ({ descricao: m.descricao, valor: m.valor })),
  ];
  const parte1 = mensalItens.map((e) => [e.descricao, brl(e.valor)]);
  const subtotal1 = mensalItens.reduce((s, e) => s + (Number(e.valor) || 0), 0);

  let startY = 78;
  if (parte1.length) {
    autoTable(doc, {
      startY,
      head: [["Mensalidade e encargos", "Valor"]],
      body: parte1,
      foot: [["Subtotal", brl(subtotal1)]],
      theme: "striped",
      headStyles: { fillColor: AZUL, textColor: 255, fontStyle: "bold" },
      footStyles: { fillColor: [241, 245, 249], textColor: [30, 41, 59], fontStyle: "bold" },
      styles: { fontSize: 9, cellPadding: 3 },
      columnStyles: { 1: { halign: "right" } },
      margin: { left: 14, right: 14 },
    });
    startY = doc.lastAutoTable.finalY + 6;
  }

  // ---------- PARTE 2: Materiais, medicamentos e serviços ----------
  const parte2 = [
    ...(fatura.itens || []).map((it) => {
      const prod = getProduto ? getProduto(it.produtoId) : null;
      const unit = prod?.precoVenda || 0;
      return [dataBR(it.data), prod?.nome || "-", String(it.qtdEmpresa), brl(unit), brl(it.valorCobrado)];
    }),
    ...manual.filter((m) => m.parte === "item").map((m) => [
      "-", m.descricao, m.quantidade ? String(m.quantidade) : "-", "-", brl(m.valor),
    ]),
  ];
  const subtotal2 = (fatura.itens || []).reduce((s, it) => s + (Number(it.valorCobrado) || 0), 0)
    + manual.filter((m) => m.parte === "item").reduce((s, m) => s + (Number(m.valor) || 0), 0);

  if (parte2.length) {
    autoTable(doc, {
      startY,
      head: [["Data", "Materiais, medicamentos e serviços", "Qtd", "Vlr Unit.", "Total"]],
      body: parte2,
      foot: [["", "Subtotal", "", "", brl(subtotal2)]],
      theme: "striped",
      headStyles: { fillColor: AZUL, textColor: 255, fontStyle: "bold" },
      footStyles: { fillColor: [241, 245, 249], textColor: [30, 41, 59], fontStyle: "bold" },
      styles: { fontSize: 9, cellPadding: 3 },
      columnStyles: { 2: { halign: "center" }, 3: { halign: "right" }, 4: { halign: "right" } },
      margin: { left: 14, right: 14 },
    });
    startY = doc.lastAutoTable.finalY + 6;
  }

  if (!parte1.length && !parte2.length) {
    doc.setFontSize(10); doc.setTextColor(148, 163, 184);
    doc.text("Nenhum lançamento nesta fatura.", 14, startY + 4);
    startY += 12;
  }

  // Observações
  if (fatura.observacao) {
    if (startY > 250) { doc.addPage(); startY = 20; }
    doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(71, 85, 105);
    doc.text("Observações", 14, startY + 4);
    doc.setFont("helvetica", "normal"); doc.setTextColor(51, 65, 85);
    const linhas = doc.splitTextToSize(fatura.observacao, 180);
    doc.text(linhas, 14, startY + 9);
    startY += 9 + linhas.length * 4.4;
  }

  // Total geral
  doc.setDrawColor(...AZUL);
  doc.setLineWidth(0.4);
  doc.line(120, startY + 6, 196, startY + 6);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(30, 41, 59);
  doc.text(`Total a pagar: ${brl(fatura.total)}`, 196, startY + 14, { align: "right" });

  if (modo === "datauri") return doc.output("datauristring");
  doc.save(`fatura-${(residente?.nome || "residente").replace(/\s+/g, "_")}-${fatura.mes}.pdf`);
}
